module.exports = __webpack_public_path__ + "static/image-bier-bewusst-genießen-cf68bbe7a96f356bf2f725c0302266a4.svg";